export class TimelineService {
  constructor($resource, ApiService, Upload, $cookies, DateService, Constants) {
    "ngInject";

    this._upload = Upload;
    this.$cookies = $cookies;
    this.$resource = $resource;
    this.dateService = DateService;
    this.apiService = ApiService;
    this.constants = Constants;

    this.timelineListUrl = this.apiService.getResourceUrl(
      "/timeline/list?isSpouseChecklist=false"
    );

    this.spouseChecklistUrl = this.apiService.getResourceUrl(
      "/timeline/list?isSpouseChecklist=true"
    );

    this.timelineEditUrl = this.apiService.getResourceUrl("/timeline/:id");

    this.timelineTaskDetailsUrl = this.apiService.getResourceUrl(
      "/timeline/:timelineId/detail"
    );

    this.timelineAddUrl = this.apiService.getResourceUrl("/timeline");

    this.timelineEditSequenceUrl =
      this.apiService.getResourceUrl("/timeline/sequence");

    // this.timelineSequence = this.apiService.getResourceUrl('/timeline/sequence')

    this.timelineSequenceResources = this.$resource(
      this.timelineEditSequenceUrl,
      null,
      {
        update: {
          method: "put",
        },
      }
    );

    this.timelineEditSequence = this.$resource(
      this.timelineEditSequenceUrl,
      null,
      {
        update: {
          method: "put",
        },
      }
    );

    this.timelineAddResources = this.$resource(this.timelineAddUrl, null, {
      update: {
        method: "post",
      },
    });

    this.timelineEditResources = this.$resource(this.timelineEditUrl, null, {
      update: {
        method: "PUT",
      },
    });

    this.timelineListResource = this.$resource(this.timelineListUrl, null, {
      update: {
        method: "POST",
      },
    });

    this.spouseChecklistResource = this.$resource(
      this.spouseChecklistUrl,
      null,
      {
        update: {
          method: "get",
        },
      }
    );

    this.timelineTaskDetailsResource = this.$resource(
      this.timelineTaskDetailsUrl,
      null,
      {
        update: {
          method: "POST",
        },
      }
    );

    this.newsletterAddResource = this.$resource(
      this.newsletterAddResourceUrl,
      null,
      {
        update: {
          method: "POST",
        },
      }
    );

    this.newsletterDetailsResource = this.$resource(
      this.newsletterUploadResourceUrl,
      null,
      {
        update: {
          method: "PUT",
          params: {
            id: "@id",
          },
        },
      }
    );
  }

  addTimeline(detail) {
    const promise = this.timelineAddResources.save(detail).$promise;
    return promise
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  getTimelineSequence() {
    const promise = this.timelineListResource.get().$promise;
    return promise
      .then((details) => {
        return {
          videoUrl: details.details.videoUrl,
          list: this._getTimelineObjectList(details.details.timelineList),
        };
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  getTimelineList(isSpouseChecklist = false) {
    if (isSpouseChecklist) {
      const promise = this.spouseChecklistResource.get().$promise;
      return promise
        .then((details) => {
          return {
            videoUrl: details.details.videoUrl,
            list: this._getTimelineObjectList(details.details.timelineList),
          };
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      const promise = this.timelineListResource.get().$promise;
      return promise
        .then((details) => {
          return {
            videoUrl: details.details.videoUrl,
            list: this._getTimelineObjectList(details.details.timelineList),
          };
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }

  getTimelineDetailsById(id) {
    const promise = this.timelineTaskDetailsResource.get({
      timelineId: id,
    }).$promise;
    return promise
      .then((details) => this.getTaskListDetails(details.details))
      .catch((error) => {
        console.log("error", error);
      });
  }

  getTaskListDetails(data) {
    let _list = data.taskList.map((task) => {
      return {
        id: task.taskId,
        task: task.task,
        description: task.task,
        plainDescription: task.plainDescription ? task.plainDescription : "",
        timelineId: task.timelineId,
        isTaskPerformed: task.isTaskPerformed,
        status: -1,
        isValid: true,
      };
    });
    const details = {
      title: data.displayName,
      bodyColor: data.bodyColor,
      borderColor: data.borderColor,
      isActive: data.isActive,
      isEnable: data.showInWebsite,
      taskLink: data.url,
      noOfQuestions: data.taskList.length,
      taskList: _list,
    };
    return details;
  }

  editTimeline(details, id) {
    const promise = this.timelineEditResources.update(
      {
        id,
      },
      details
    ).$promise;
    return promise
      .then((response) => response)
      .catch((err) => {
        console.log(err);
      });
  }

  editTimelineSequences(details) {
    const promise = this.timelineEditSequence.update(details).$promise;

    return promise
      .then((response) => response)
      .catch((err) => {
        console.log("err", err);
      });
  }

  getSurveyDeatilsById() {
    return {
      id: 2,
      title: "24 - 12 months",
      noOfQuestion: "5",
    };
  }

  deleteNewsletter(id) {
    const promise = this.timelineEditResources.delete({
      id,
    }).$promise;
    return promise
      .then((response) => response)
      .catch((err) => {
        console.log("err", err);
      });
  }

  _getTimelineObjectList(list) {
    return list.map((value) => this._getTimelineObject(value));
  }

  _getTimelineObject(data) {
    return {
      id: data.timelineId,
      showInWebsite: data.showInWebsite,
      isTimelinePerformed: data.isTimelinePerformed,
      title: data.displayName,
      is_archive: data.showInWebsite,
      sortOrder: data.sortOrder,
      noOfQuestion: data.taskCount,
      createdAt: data.created_at,
    };
  }

  _setNewsletterObject(value) {
    return {
      display_name: value.title,
      pdf: value.pdf,
      user_type: value.userType,
      is_archived: value.is_archive,
      display_on_mobile: value.displayOnMobile,
    };
  }
  _getNewsletterDownloadUrl(id) {
    return this.apiService.getResourceUrl(
      "v1/files/" + id + "?jwt=" + this.$cookies.get("token")
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline.service.js